<style scoped  lang="less">
  @import '../../../style/reset.less'; // 引入公共LESS文件
  .crumbs{
    // .flex();
    // .flex-align-center();
    font-size: 0;white-space: nowrap;
    padding: 11px 8px;
    font-weight: 400; 
    color:@color_8C8C8C; 
    border-bottom: 1px solid @color_F0F0F0;
    *{height: 18px;display: inline-block; vertical-align: top; font-size: 14px; height: 18px; line-height: 18px; }
    i{width: 18px;margin-right: 8px; 
      position: relative;
      &:before {
      font-family: "iconfont" !important;position: absolute;left: 0;top:0;width: 100%;height: 100%;
      content: "\e601"; font-size: 18px; line-height: 18px;color:#8C8C8C;text-align: center;
    }
    
    }
    s{width: 16px;margin: 0 2px;position: relative;
      &:before {
          content: "";display: block;position: absolute;right: 0px;top:9px;
          width: 6px;height: 6px;border-top: 1px solid @color_8C8C8C;border-left: 1px solid @color_8C8C8C;
          transform: translate(-50%,-50%) rotate(135deg);
      }
    }
    a{
      color:@color_8C8C8C; display: inline-block; vertical-align: middle;
      img{
        display: inline-block; vertical-align: middle;width: 18px; 
          height: 12px; border: 1px solid @color_D9D9D9;margin: 0;margin-right: 6px;
      }
      &.a_noUrl{
        user-select: none !important;
       
      }
    }
    .span_shortName{display: none;}
  }

@media screen and (max-width: 767px) {
  .crumbs{
    padding: 0.08rem 0.12rem;
   overflow-x:auto ; 
   &::-webkit-scrollbar {
          width: 0rem; display: none!important;
        }
    *{height: 0.18rem; white-space: nowrap;font-size: 0.14rem; height: 0.18rem; line-height: 0.18rem;}
    i{ display: none;
    }
    s{width: 0.16rem;margin: 0 0.02rem;
      &:before {
          top:0.09rem;
          width: 0.06rem;height: 0.06rem;
      }
    }
    a{
      img{display: none;
      }
      
    }
    .span_fullName{display: none;}
    .span_shortName{display: inline;}
  }

}
.a_last{color: @color_434343 !important;}

</style>
<template>
  <div>
    <div class="crumbs" v-if="league!=null">
        <i></i>
        <a class="a_noUrl">{{ langConfig.footer[langConfig.curLang]['FOOTBALL'] }}</a> 
        <s></s>
        <router-link :to="{path:'/'}">
          {{ langConfig.footer[langConfig.curLang]['SCORE'] }}
        </router-link>
        <!-- <a href="javascript:void(0);">Scores</a>  -->
        <s></s>
        <template>
          <router-link class=" flex flex-align-center a_last" :to="{path:'/leagues/' + league.id+'/0'}" v-if="league.hasDt">
            <img  :src="common.noCountryBack(league, 'img')" @error="common.imgError($event, 'country')" alt="">
            <span class="span_fullName">{{common.noCountryBack(league, 'name')}}{{league.fullName}}</span>
            <span class="span_shortName">{{common.noCountryBack(league, 'name')}}{{league.shortName}}</span>
            
          </router-link>
          <a href="javascript:void(0);" class="a_noUrl a_last" v-else>
            <img  :src="common.noCountryBack(league, 'img')" @error="common.imgError($event, 'country')" alt="">
            <span class="span_fullName">{{common.noCountryBack(league, 'name')}}{{league.fullName}}</span>
            <span class="span_shortName">{{common.noCountryBack(league, 'name')}}{{league.shortName}}</span>
          </a>
        </template>
        <!-- <a href="javascript:void(0);" class="flex flex-align-center">
          <img  :src="common.countryImgGet(league['country']['id'])" alt="">
          <span>{{league['country'].name}} : {{league.fullName}}</span>
        </a>  -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
  
  created() {
    
  
  },
  methods: { 
   
  },
  watch: {

  },
  mounted() {
    
  },
  beforeDestroy() {
   
  },
  props: {
    league: {
      type: Object,
      default:null
    }, 
    // options:{
    //   type:Array,
    //   default:() =>[],
    // },
    // format: {
    //   type: String,
    //   default:'DD/MM/YYYY WW'
    // },
    // showToday:{
    //   type: Boolean,
    //   default:false
    // },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsCrumbs.vue